import Glide from '@glidejs/glide';

export default function (dom, opts) {
	let options = {
		type: 'carousel',
		perView: 1,
		gap: 0,
		keyboard: false,
		autoplay: false,
		breakpoints: {
			1279: {
				perView: 1,
			},
			767: {
				perView: 1,
				autoplay: false,
				hoverpause: true
			},
		},
		swipeThreshold: 80,
		dragThreshold: 120,
		perTouch: 0,
		touchRatio: 0.5,
		touchAngle: 45,
		rewind: true,
		...opts
	};



	const singleImage = dom.querySelector('.brand-slider__background');
	const singleSlide = dom.querySelector('.glide__slide');
	const allSlides = Array.from(dom.querySelectorAll('.brand-slider__single'));
	const arrowButton = Array.from(dom.querySelectorAll('.glide__arrow'));
	const testField = dom.querySelector('.test-field');

	const slideCount = [].slice.call(dom.querySelectorAll('.glide__slide'), 0).length;

	if (slideCount) {
		const glide = new Glide(dom.querySelector('.glide'), options).mount();

        function cloneImage () {

            arrowButton.forEach(el => {
                el.addEventListener('click', () => {
                    console.log('clicked')
       /*             allSlides.forEach(el => {
                        testField.appendChild(singleImage.cloneNode(true))
                    })*/
                    // testField.removeChild(singleSlide)
                    testField.appendChild(singleSlide.cloneNode(true))
                })
            })

        }
        // cloneImage();








	}
}
